<template>

  <div>
    <!--列表-->
    <Index v-if="activeName == 'index'"></Index>
    

    <!--设置-->
    <Setting v-if="activeName == 'setting'"></Setting>

  </div>
</template>
<script>
import bus from '@/utils/eventBus.js';
import Index from './index/list';
import Setting from './index/setting';

export default {
  components: {
    Index,
    Setting
  },
  data() {
    return {
      /*参数*/
      param: {},
      /*当前选中*/
      activeName: 'index',
      /*切换数组原始数据*/
      sourceList: [
        {
          key: 'index',
          value: '物流列表',
          path:'/plus/express/index/list'
        },
        {
          key: 'setting',
          value: '设置',
          path:'/plus/express/index/setting'
        }
      ],
      /*权限筛选后的数据*/
      tabList:[],
    };
  },
  created() {

    this.tabList=this.authFilter();

    if(this.tabList.length>0){
      this.activeName=this.tabList[0].key;
    }

    if (this.$route.query.type != null) {
      this.activeName = this.$route.query.type;
    }

    /*监听传插件的值*/
    bus.$on('activeValue', res => {
      this.activeName = res;
    });

    //发送类别切换
    let params = {
      active: this.activeName,
      list: this.tabList,
      tab_type: 'regionagent'
    };
    bus.$emit('tabData', params);
  },
  beforeDestroy() {
    //发送类别切换
    bus.$emit('tabData', { active: null, tab_type: 'regionagent', list: [] });
    bus.$off('activeValue');
  },
  methods: {

    /*权限过滤*/
    authFilter(){
      let list=[];
      for(let i=0;i<this.sourceList.length;i++){
        let item=this.sourceList[i];
        if(this.$filter.isAuth(item.path)){
          list.push(item);
        }
      }
      return list;
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/views/plus/express/index.vue